(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-home-cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tr-home-cart')) {
  customElements.define('tr-home-cart', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      const signal = this.lifecycle.signal;
      this.dialog = this.querySelector('dialog');
      this.status = this.querySelector('[data-cart-status]');
      this.fallback = this.querySelector('[data-cart-fallback]');
      this.ready = typeof this.dialog?.showModal === 'function';
      if (!this.ready) return;
      this.addEventListener('click', event => {
        const review = event.target.closest('[data-cart-review]');
        if (review) { if (this.busy) event.preventDefault(); return; }
        const close = event.target.closest('[data-cart-close]');
        if (close) { this.dialog.close(); return; }
        const offer = event.target.closest('[data-cart-offer]');
        if (offer) {
          if (!this.busy && !this.stale) this.acceptOffer(offer);
          return;
        }
        const button = event.target.closest('[data-cart-action]');
        if (!button || this.busy || this.stale) return;
        const line = button.closest('[data-cart-key]');
        const quantity = Number(line.dataset.quantity);
        const step = Number(line.dataset.step) || 1;
        const minimum = Number(line.dataset.min) || 1;
        const next = button.dataset.cartAction === 'remove' ? 0 : button.dataset.cartAction === 'increase' ? quantity + step : Math.max(minimum, quantity - step);
        this.change(line.dataset.cartKey, next, button.dataset.cartAction);
      }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('tr-cart-open');
        document.body.classList.remove('tr-cart-open');
        this.returnFocus?.focus({ preventScroll: true });
      }, { signal });
      document.addEventListener('click', event => {
        const link = event.target.closest('#cart-icon-bubble');
        if (!link || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.open(link);
        this.enqueue(async () => {
          this.message(this.dataset.loading);
          try { await this.refresh(); this.message(''); }
          catch (error) {
            console.warn('TrailRoot cart refresh unavailable:', error.message);
            this.unavailable(this.dataset.refreshError);
          }
        });
      }, { signal, capture: true });
    }
    enqueue(task) {
      const work = (this.queue || Promise.resolve()).catch(() => {}).then(async () => {
        if (!this.isConnected) return;
        this.setBusy(true);
        try { return await task(); }
        finally { this.setBusy(false); }
      });
      this.queue = work;
      return work;
    }
    setBusy(value) {
      this.busy = value;
      this.querySelector('[data-cart-render]')?.setAttribute('aria-busy', String(value));
      const fields = this.querySelector('[data-cart-fields]');
      if (fields) fields.disabled = value || this.stale === true;
      this.querySelector('[data-cart-review]')?.setAttribute('aria-disabled', String(value));
    }
    message(text, error = false) {
      this.status.textContent = text;
      this.status.dataset.error = String(error);
    }
    open(trigger) {
      if (!this.dialog.open) {
        this.returnFocus = trigger || document.activeElement;
        this.dialog.showModal();
        document.documentElement.classList.add('tr-cart-open');
        document.body.classList.add('tr-cart-open');
      }
    }
    unavailable(message) {
      this.stale = true;
      this.setBusy(this.busy);
      this.fallback.hidden = false;
      this.message(message, true);
    }
    async request(url, options = {}) {
      const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json', ...options.headers }, ...options });
      let data;
      try { data = await response.json(); } catch { throw new Error('Unconfirmed response'); }
      if (!response.ok || data.status >= 400) {
        const error = new Error('Cart update rejected');
        if (typeof data.description === 'string') error.cartMessage = data.description;
        throw error;
      }
      return data;
    }
    async refresh() {
      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('sections', this.dataset.sectionId + ',cart-icon-bubble');
      // Let the sections query select the response format. Accept: application/json
      // can select the cart/product JSON endpoint instead of rendering the theme.
      const sections = await this.request(url, { cache: 'no-store', headers: { Accept: '*/*' } });
      if (!this.render(sections)) throw new Error('Cart section unavailable');
    }
    render(sections, focus) {
      const html = sections?.[this.dataset.sectionId];
      if (typeof html !== 'string') return false;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const content = parsed.querySelector('tr-home-cart [data-cart-render]');
      if (!content) return false;
      const scroll = this.querySelector('.tr-cart__items')?.scrollTop || 0;
      this.querySelector('[data-cart-render]').replaceWith(content);
      this.stale = false;
      this.fallback.hidden = true;
      this.setBusy(this.busy);
      const list = this.querySelector('.tr-cart__items');
      if (list) list.scrollTop = scroll;
      const bubble = document.getElementById('cart-icon-bubble');
      const markup = sections['cart-icon-bubble'];
      const icon = typeof markup === 'string' ? new DOMParser().parseFromString(markup, 'text/html').querySelector('.shopify-section') : null;
      if (bubble && icon) bubble.replaceChildren(...icon.childNodes);
      else if (bubble) {
        bubble.querySelector('.cart-count-bubble')?.remove();
        const count = Number(content.dataset.cartCount);
        if (count > 0) {
          const badge = document.createElement('div');
          badge.className = 'cart-count-bubble';
          const visible = document.createElement('span');
          visible.setAttribute('aria-hidden', 'true');
          visible.textContent = count < 100 ? String(count) : '99+';
          const accessible = document.createElement('span');
          accessible.className = 'visually-hidden';
          accessible.textContent = this.dataset.countLabel.replace('[count]', String(count));
          badge.append(visible, accessible);
          bubble.append(badge);
        }
      }
      if (focus && this.dialog.open) {
        this.focusAfterUpdate = focus;
      }
      window.dispatchEvent(new CustomEvent('tr:cart-changed'));
      return true;
    }
    restoreLineFocus() {
      const focus = this.focusAfterUpdate;
      this.focusAfterUpdate = null;
      if (!focus || !this.dialog.open) return;
      const line = [...this.querySelectorAll('[data-cart-key]')].find(item => item.dataset.cartKey === focus.key);
      const button = line?.querySelector('[data-cart-action="' + focus.action + '"]:not(:disabled)');
      (button || line?.querySelector('.tr-cart__product') || this.querySelector('[data-cart-close]')).focus({ preventScroll: true });
    }
    notifyCartUpdate() {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { source: 'trailroot-cart' })).catch(() => {});
      }
    }
    add(form, trigger, beforeOpen) {
      return this.enqueue(async () => {
        const body = new FormData(form);
        body.set('sections', this.dataset.sectionId + ',cart-icon-bubble');
        body.set('sections_url', window.location.pathname);
        const url = new URL(form.action, window.location.origin);
        url.pathname = url.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
        const result = await this.request(url, { method: 'POST', body });
        if (!result.id && !result.items?.length) throw new Error('Unconfirmed addition');
        const rendered = this.render(result.sections);
        beforeOpen?.();
        this.open(trigger);
        this.notifyCartUpdate();
        if (!rendered) {
          try { await this.refresh(); }
          catch { this.unavailable(this.dataset.addedFallback); return; }
        }
        this.message(this.dataset.added);
      });
    }
    change(key, quantity, action) {
      this.enqueue(async () => {
        this.message(this.dataset.loading);
        const body = { id: key, quantity, sections: [this.dataset.sectionId, 'cart-icon-bubble'], sections_url: window.location.pathname };
        try {
          const result = await this.request(this.dataset.changeUrl + '.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
          if (!Number.isInteger(result.item_count)) throw new Error('Unconfirmed quantity');
          this.notifyCartUpdate();
          if (!this.render(result.sections, { key, action })) {
            await this.refresh();
            this.focusAfterUpdate = { key, action };
          }
          this.message(this.dataset.updated);
        } catch (error) {
          try { await this.refresh(); this.focusAfterUpdate = { key, action }; }
          catch { this.unavailable(this.dataset.error); return; }
          this.message(error.cartMessage || this.dataset.error, true);
        }
      }).then(() => this.restoreLineFocus()).catch(() => this.unavailable(this.dataset.error));
    }
    acceptOffer(button) {
      const offer = { ...button.dataset };
      // Lock immediately: a rapid double-click must not enqueue a second purchase.
      this.setBusy(true);
      return this.enqueue(async () => {
        this.message(this.dataset.loading);
        try {
          // Recheck server-rendered eligibility, including the contents of kits
          // added in another tab since this offer was first shown.
          await this.refresh();
          const eligible = [...this.querySelectorAll('[data-cart-offer]')].some(candidate =>
            candidate.dataset.variantId === offer.variantId &&
            candidate.dataset.cartOffer === offer.cartOffer &&
            (offer.cartOffer !== 'upgrade' ||
              (candidate.dataset.sourceKey === offer.sourceKey && candidate.dataset.sourceQuantity === offer.sourceQuantity && candidate.dataset.upgradeKind === offer.upgradeKind))
          );
          if (!eligible) {
            this.message(this.dataset.offerChanged, true);
            return;
          }
          const before = await this.request(this.dataset.cartUrl + '.js', { cache: 'no-store' });
          const target = String(offer.variantId);
          const exists = before.items.some(item => String(item.variant_id) === target || item.item_components?.some(component => String(component.variant_id) === target));
          const source = before.items.find(item => item.key === offer.sourceKey);
          const upgrade = offer.cartOffer === 'upgrade';
          const sourceChanged = upgrade && (!source || source.quantity !== Number(offer.sourceQuantity) || source.selling_plan_allocation || source.parent_relationship || source.item_components?.length || Object.keys(source.properties || {}).length);
          if (exists || sourceChanged) {
            await this.refresh();
            this.message(this.dataset.offerChanged, true);
            return;
          }
          const body = { sections: [this.dataset.sectionId, 'cart-icon-bubble'], sections_url: window.location.pathname };
          if (upgrade) {
            // Only a NEW kit variant is added. Shopify update.js does not check
            // stock for variants already in the cart, which are excluded above.
            body.updates = { [source.key]: source.quantity - 1, [target]: 1 };
          } else {
            body.items = [{ id: Number(target), quantity: 1 }];
          }
          const endpoint = upgrade ? this.dataset.updateUrl : this.dataset.addUrl;
          const result = await this.request(endpoint + '.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
          if (upgrade ? !Number.isInteger(result.item_count) : !result.items?.length) throw new Error('Unconfirmed offer');
          this.notifyCartUpdate();
          if (!this.render(result.sections)) await this.refresh();
          this.message(upgrade ? (offer.upgradeKind === 'tools' ? this.dataset.toolsUpgraded : this.dataset.upgraded) : this.dataset.added);
        } catch (error) {
          // Never replay a purchase after an uncertain response. Reconcile by GET.
          try { await this.refresh(); }
          catch { this.unavailable(this.dataset.error); return; }
          this.message(error.cartMessage || this.dataset.error, true);
        }
      }).then(() => {
        if (this.dialog.open) this.querySelector('[data-cart-review]')?.focus({ preventScroll: true });
      }).catch(() => this.unavailable(this.dataset.error));
    }
    disconnectedCallback() {
      this.ready = false;
      if (this.dialog?.open) this.dialog.close();
      this.lifecycle?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tr-forest-hero')) {
  customElements.define('tr-forest-hero', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.lifecycle = new AbortController();
      const signal = this.lifecycle.signal;
      this.paused = false;
      this.inView = true;
      this.duration = 5000;
      this.remaining = this.duration;
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.control = this.querySelector('.tr-home-motion');
      this.slides = [...this.querySelectorAll('.tr-home-hero__slide')];
      this.buttons = [...this.querySelectorAll('[data-scene-index]')];
      this.navigation = this.querySelector('.tr-home-hero__navigation');
      this.caption = this.querySelector('[data-scene-title]');
      this.notes = this.querySelector('[data-scene-notes]');
      this.shopLink = this.querySelector('[data-scene-link]');
      this.hoveringShop = false;
      this.shopLink?.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hoveringShop = true; this.sync(); } }, { signal });
      this.shopLink?.addEventListener('pointerleave', () => { this.hoveringShop = false; this.sync(); }, { signal });
      this.status = this.querySelector('[data-scene-status]');
      this.activeIndex = Math.max(0, this.slides.findIndex(slide => slide.dataset.active === 'true'));
      this.navigation.hidden = this.slides.length < 2;
      this.headers = [...document.querySelectorAll('.shopify-section-group-header-group')];
      this.values = this.nextElementSibling;
      this.copy = this.querySelector('.tr-home-hero__copy');
      this.measure = () => {
        const headerHeight = this.headers.reduce((height, section) => height + section.getBoundingClientRect().height, 0);
        this.style.setProperty('--tr-header-height', headerHeight + 'px');
        this.style.setProperty('--tr-values-height', (this.values?.getBoundingClientRect().height || 0) + 'px');
        this.style.setProperty('--tr-copy-height', (this.copy?.getBoundingClientRect().height || 0) + 'px');
      };
      this.reset = () => {
        cancelAnimationFrame(this.frame);
        this.style.setProperty('--tr-x', '0px');
        this.style.setProperty('--tr-y', '0px');
      };
      this.sync = () => {
        const enabled = this.dataset.motion === 'true' && !this.preference.matches;
        this.control.hidden = !enabled || !this.slides.length;
        this.running = enabled && !this.paused && !this.hoveringShop && this.inView && !document.hidden;
        this.dataset.running = String(this.running);
        this.control.textContent = this.paused ? this.control.dataset.play : this.control.dataset.pause;
        this.control.setAttribute('aria-label', this.control.textContent);
        this.control.title = this.control.textContent;
        this.control.dataset.paused = String(this.paused);
        const readySlides = this.slides.filter(slide => slide.dataset.ready === 'true');
        if (!this.running || readySlides.length < 2) {
          this.clearClock();
          if (!this.running) this.reset();
          return;
        }
        if (this.timer != null) return;
        this.startedAt = performance.now();
        this.timer = setTimeout(() => {
          this.timer = null;
          this.remaining = this.duration;
          for (let offset = 1; offset < this.slides.length; offset++) {
            const next = (this.activeIndex + offset) % this.slides.length;
            if (this.slides[next].dataset.ready === 'true') {
              this.activate(next);
              return;
            }
          }
          this.sync();
        }, this.remaining);
      };
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.activate(index, true), { signal });
      });
      this.slides.forEach((slide, index) => {
        const picture = slide.querySelector('img');
        const ready = async () => {
          try { await picture.decode(); } catch {}
          if (signal.aborted || !picture.naturalWidth) return;
          slide.dataset.ready = 'true';
          this.buttons[index].disabled = false;
          if (this.slides[this.activeIndex]?.dataset.failed === 'true') this.activate(index);
          this.sync();
        };
        const failed = () => {
          slide.dataset.failed = 'true';
          slide.dataset.ready = 'false';
          this.buttons[index].disabled = true;
          const replacement = this.slides.findIndex(item => item.dataset.ready === 'true');
          if (index === this.activeIndex && replacement >= 0) this.activate(replacement);
          this.sync();
        };
        picture.addEventListener('load', ready, { signal });
        picture.addEventListener('error', failed, { signal });
        if (picture.complete) {
          if (picture.naturalWidth) ready();
          else failed();
        }
        slide.addEventListener('transitionend', event => {
          if (event.target === slide && event.propertyName === 'opacity' && slide.dataset.active !== 'true') slide.dataset.leaving = 'false';
        }, { signal });
      });
      this.control.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, { signal });
      this.addEventListener('focusin', event => {
        if (event.target !== this.control && event.target.matches(':focus-visible')) {
          this.paused = true;
          this.sync();
        }
      }, { signal });
      this.preference.addEventListener('change', this.sync, { signal });
      document.addEventListener('visibilitychange', this.sync, { signal });
      window.addEventListener('resize', this.measure, { signal });
      this.resizeObserver = new ResizeObserver(this.measure);
      this.headers.forEach(section => this.resizeObserver.observe(section));
      if (this.values) this.resizeObserver.observe(this.values);
      if (this.copy) this.resizeObserver.observe(this.copy);
      this.observer = new IntersectionObserver(([entry]) => { this.inView = entry.isIntersecting; this.sync(); });
      this.observer.observe(this);
      this.addEventListener('pointermove', event => {
        if (!this.running || !matchMedia('(pointer: fine)').matches) return;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const bounds = this.getBoundingClientRect();
          this.style.setProperty('--tr-x', ((event.clientX - bounds.left) / bounds.width - .5) * 10 + 'px');
          this.style.setProperty('--tr-y', ((event.clientY - bounds.top) / bounds.height - .5) * 6 + 'px');
        });
      }, { signal });
      this.addEventListener('pointerleave', this.reset, { signal });
      this.measure();
      this.sync();
    }
    clearClock(preserve = true) {
      if (this.timer == null) return;
      if (preserve) this.remaining = Math.max(0, this.remaining - (performance.now() - this.startedAt));
      clearTimeout(this.timer);
      this.timer = null;
    }
    activate(index, manual = false) {
      const next = this.slides[index];
      if (!next || next.dataset.ready !== 'true' || index === this.activeIndex) return;
      this.clearClock(false);
      this.remaining = this.duration;
      this.slides.forEach((slide, slideIndex) => {
        const leaving = slide.dataset.active === 'true' && slideIndex !== index;
        slide.dataset.leaving = String(leaving && !this.preference.matches);
        slide.dataset.active = String(slideIndex === index);
      });
      this.activeIndex = index;
      this.dataset.scent = next.dataset.scent;
      this.caption.textContent = next.dataset.title;
      this.notes.textContent = next.dataset.notes;
      if (this.shopLink) {
        this.shopLink.href = next.dataset.url || '#trailroot-scents';
        this.shopLink.setAttribute('aria-label', next.dataset.shopLabel || next.dataset.title);
      }
      this.buttons.forEach((button, buttonIndex) => button.setAttribute('aria-pressed', String(buttonIndex === index)));
      if (manual) this.status.textContent = next.dataset.title + '. ' + next.dataset.notes;
      this.sync();
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.clearClock(false);
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-home-scents"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tr-scent-cart')) {
  customElements.define('tr-scent-cart', class extends HTMLElement {
    static queue = Promise.resolve();
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type=submit]');
      this.label = this.button.querySelector('span');
      this.initialLabel = this.initialLabel || this.label.textContent;
      this.status = this.querySelector('[role=status]');
      this.view = this.querySelector('.tr-scent-cart__view');
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.busy) return;
        this.busy = true;
        this.button.disabled = true;
        this.setAttribute('aria-busy', 'true');
        this.label.textContent = this.dataset.adding;
        this.status.textContent = '';
        this.view.hidden = true;
        this.constructor.queue = this.constructor.queue.catch(() => {}).then(() => this.add());
      }, { signal: this.lifecycle.signal });
    }
    async add() {
      try {
        if (!this.isConnected) return;
        const drawer = document.querySelector('tr-home-cart');
        if (typeof drawer?.add === 'function' && drawer.ready) {
          await drawer.add(this.form, this.button);
          this.dataset.state = 'added';
          this.status.textContent = this.dataset.added;
          this.view.hidden = false;
          return;
        }
        const body = new FormData(this.form);
        body.set('sections', 'cart-icon-bubble');
        body.set('sections_url', window.location.pathname);
        const endpoint = new URL(this.form.action, window.location.origin);
        endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
        const response = await fetch(endpoint, { method: 'POST', headers: { Accept: 'application/json' }, body, credentials: 'same-origin' });
        const result = await response.json();
        if (!response.ok || result.status) {
          this.dataset.state = 'error';
          this.status.textContent = typeof result.description === 'string' ? result.description : this.dataset.error;
          this.view.hidden = false;
          return;
        }
        if (!result.id) throw new Error('Unconfirmed cart response');
        this.dataset.state = 'added';
        this.status.textContent = this.dataset.added;
        this.view.hidden = false;
        const markup = result.sections?.['cart-icon-bubble'];
        const target = document.getElementById('cart-icon-bubble');
        const content = typeof markup === 'string' ? new DOMParser().parseFromString(markup, 'text/html').querySelector('.shopify-section') : null;
        if (target && content) target.replaceChildren(...content.childNodes);
        else await this.refreshCount();
        window.dispatchEvent(new CustomEvent('tr:cart-changed'));
      } catch (error) {
        this.dataset.state = 'error';
        this.status.textContent = error.cartMessage || this.dataset.error;
        this.view.hidden = false;
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.removeAttribute('aria-busy');
        this.label.textContent = this.initialLabel;
      }
    }
    async refreshCount() {
      try {
        const response = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (!response.ok) return;
        const cart = await response.json();
        const target = document.getElementById('cart-icon-bubble');
        if (!target || !Number.isInteger(cart.item_count)) return;
        target.querySelector('.cart-count-bubble')?.remove();
        if (!cart.item_count) return;
        const bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        const visible = document.createElement('span');
        visible.setAttribute('aria-hidden', 'true');
        visible.textContent = cart.item_count < 100 ? String(cart.item_count) : '99+';
        const accessible = document.createElement('span');
        accessible.className = 'visually-hidden';
        accessible.textContent = this.dataset.count.replace('[count]', String(cart.item_count));
        bubble.append(visible, accessible);
        target.append(bubble);
      } catch {}
    }
    disconnectedCallback() { this.lifecycle?.abort(); }
  });
}

if (!customElements.get('tr-scent-guide')) {
  customElements.define('tr-scent-guide', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      const details = this.querySelector('details');
      const reveal = () => { if (location.hash === '#' + details.id) details.open = true; };
      document.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (link?.getAttribute('href') === '#' + details.id) details.open = true;
      }, { signal: this.lifecycle.signal });
      window.addEventListener('hashchange', reveal, { signal: this.lifecycle.signal });
      reveal();
    }
    disconnectedCallback() { this.lifecycle?.abort(); }
  });
}


  } catch(e) { console.error(e); }
})();
})();
